/**
 * Main Client Entry Point
 */

import '../styles/index.css';
import { portfolioData } from '../data/portfolio-data.js';
import { initNavigation } from './navigation.js';
import { initScrollReveal } from './reveal.js';
import { initProjectModal } from './modal.js';

document.addEventListener('DOMContentLoaded', () => {
  // Set current year in copyright footer
  const yearEl = document.getElementById('year');
  if (yearEl) {
    yearEl.textContent = new Date().getFullYear();
  }

  // Initialize navigation & scrollspy
  initNavigation();

  // Initialize scroll reveal animations
  initScrollReveal();

  // Initialize interactive project details modal
  initProjectModal();
});

